const getFileExtensions = filename => filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;

export default getFileExtensions;
